import React from "react";
import { Redirect } from "react-router-dom";

export function redirect(path: string): React.FunctionComponent {
  return () => React.createElement(Redirect, { to: path });
}
